export class SyntheseInventaireUniteEdition {
    static jsonMap = {
        referenceCadastrale: { key: 'referenceCadastrale', optional: true, default: '' },
        commune: { key: 'commune', optional: true, default: '' },
        lieuDit: { key: 'lieuDit', optional: true, default: '' },
        numBlocFruitier: { key: 'numBlocFruitier', optional: true, default: '' },
        numTracabilite: { key: 'numTracabilite', optional: true, default: '' },
        codeParcelle: { key: 'codeParcelle', optional: true, default: '' },
        variete: { key: 'variete', optional: true, default: '' },
        clone: { key: 'clone', optional: true, default: '' },
        anneePlantation: { key: 'anneePlantation', optional: true },
        anneePremiereFeuille: { key: 'anneePremiereFeuille', optional: true },
        anneeSurgreffage: { key: 'anneeSurgreffage', optional: true },
        distanceIntraRang: { key: 'distanceIntraRang', optional: true },
        distanceInterRang: { key: 'distanceInterRang', optional: true },
        nbArbre: { key: 'nbArbre', optional: true },
        surfaceCalculee: { key: 'surfaceCalculee', optional: true },
        porteGreffe: { key: 'porteGreffe', optional: true, default: '' },
        refSystemeIrrigation: { key: 'refSystemeIrrigation', optional: true },
        refProtectionGel: { key: 'refProtectionGel', optional: true },
        refProtectionGrele: { key: 'refProtectionGrele', optional: true },
        refCultureBio: { key: 'refCultureBio', optional: true },
        forme: { key: 'forme', optional: true, default: '' }
    };

    public referenceCadastrale: string;
    public commune: string;
    public lieuDit: string;
    public numBlocFruitier: string;
    public numTracabilite: string;
    public codeParcelle: string;
    public variete: string;
    public clone: string;
    anneePlantation: number;
    anneePremiereFeuille: number;
    anneeSurgreffage: number;
    distanceIntraRang: number;
    distanceInterRang: number;
    nbArbre: number;
    surfaceCalculee: number;
    public porteGreffe: string;
    public refSystemeIrrigation: boolean;
    public refProtectionGel: boolean;
    public refProtectionGrele: boolean;
    public refCultureBio: boolean;
    public forme: string;
}
